// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SIL_","colBig":"styles_colBig__2zX1S","colSmall":"styles_colSmall__8V5PT"};